import {
  Calendar,
  CircleDot,
  FileText,
  Hash,
  ListChecks,
  ListOrdered,
  SlidersHorizontal,
  Type,
  User,
  AlignLeft,
  type LucideIcon,
} from 'lucide-react';
import type { SurveyStep } from '../../types/survey';

// Phase 6B B3 — pure presentation helpers for the step cards. Label + icon per
// step type, and a one-line summary of the card's content.

type StepKindKey = SurveyStep extends { type: infer T } ? T : never;

export const STEP_TYPE_LABEL: Record<StepKindKey, string> = {
  yes_no: 'Yes / No',
  multiple_choice_single: 'Multiple choice',
  multiple_choice_multi: 'Multiple choice (multi)',
  short_text: 'Short text',
  long_text: 'Long text',
  rating_scale: 'Rating scale',
  date: 'Date',
  number: 'Number',
  name: 'Name',
  content_page: 'Content page',
};

export const STEP_TYPE_ICON: Record<StepKindKey, LucideIcon> = {
  yes_no: CircleDot,
  multiple_choice_single: ListChecks,
  multiple_choice_multi: ListChecks,
  short_text: Type,
  long_text: AlignLeft,
  rating_scale: SlidersHorizontal,
  date: Calendar,
  number: Hash,
  name: User,
  content_page: FileText,
};

// Suppress unused-import noise without weakening the icon map's completeness.
void ListOrdered;

// One-line content summary for the collapsed card.
export function summarizeStep(step: SurveyStep): string {
  if (step.kind === 'content') return step.title.trim() || '(untitled page)';
  return step.prompt.trim() || '(no prompt yet)';
}

// Inline branching summary (B5 fills the editor; the card shows the gist).
export function branchingSummary(step: SurveyStep): string {
  if (step.kind === 'content') return 'Continues to next';
  const rules = step.branching;
  if (rules.length === 0) return 'Default: next question';
  if (rules.length === 1) return '1 branching rule';
  return `${rules.length} branching rules`;
}
